import { defaultPack } from '@tickitacka/shared';

export const MOBILE_WIDTH = 767;

export const NAVBAR_WIDTH = 72;
export const SECONDARY_SIDEBAR_WIDTH = 200;
export const SECONDARY_SIDEBAR_COLLAPSED_WIDTH = 60;
export const HEADER_HEIGHT = 51 - 8; // bottom padding은 main body의 top margin으로 적용해서 제외 (8px)

/**
 * todo.is_public false일 경우 title
 */
export const PRIVATE_TODO_TITLE_KEY = 'todo:private_todo_title';

export const DESCRIPTION_PLACEHOLDER_KEY = 'placeholder.description';

/**
 * 알림 메시지 최대 표시 길이
 */
export const MAX_NOTIFICATION_DISPLAY_LENGTH = 20;

/**
 * 피드백 탭 이름 상수
 */
export const TAB_RECEIVED_FEEDBACK = 'receivedFeedback';
export const TAB_SENT_FEEDBACK = 'sentFeedback';
export const TAB_RECEIVED_REQUEST = 'receivedRequest';
export const TAB_SENT_REQUEST = 'sentRequest';

// 모바일에서 스토어로 이동 시 사용, 보안상 민감한 정보 아니어서 상수로 정의
// export const APP_STORE_ID = '6743928304';
// export const PLAY_STORE_ID = 'com.tickitacka_light_app';

export const DEFAULT_LANGUAGE = defaultPack['default-language'];

export const PERSONAL_PAGES = ['auth', 'planner', 'drive', 'note'];

/**
 * 탈퇴한 사용자 관련 유틸리티 함수들
 * @deprecated 이 함수들은 @tickitacka/shared/utils/userUtils로 이동되었습니다.
 * 하위 호환성을 위해 re-export하고 있으니, 새 코드에서는 shared에서 직접 import해주세요.
 */
export {
    DELETED_USER_ID,
    createDeletedUser,
    toSafeUserArray,
    getUserFromWorkspace,
} from '@tickitacka/shared';
